import { useState, useEffect } from "react";

// material
import { Box, Card, Container } from "@mui/material";
import Label from "../Label";
// components
import Scrollbar from "../table/Scrollbar";
import ListToolbar from "../table/ListToolbar";
import TableView from "../Table";
import { parseDateTime } from "../../utils/tableFunctions";
import {
  getHistoryGroupFilterConditions,
  getHistoryGroupList,
} from "../../services/services";

import { SingleSelectType } from "../table/Filter";
import CircularLoader from "../circularLoader";
import CommonDialog from "../CustomDialog";
import GroupDetails from "../../pages/details/admin/GroupDetails";
import { pageNumber, rowsPerPage } from "../../utils/constants";

// ----------------------------------------------------------------------

export default function HistoryGroup() {
  const [historyGroup, setHistoryGroup] = useState({ results: [], count: 0 });
  const [loaded, setLoaded] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [selected, setSelected] = useState([]);
  const [filterName, setFilterName] = useState();
  const [fParams, setFParams] = useState({});
  const [itemId, setItemId] = useState(null);

  const [pagination, setPagination] = useState({
    page: pageNumber,
    page_size: rowsPerPage,
  });

  // ------------------ filterStuffies --------------------//
  const [reset, setReset] = useState(false);
  const [fLoaded, setFLoaded] = useState(false);
  const [historyGroupFilter, setHistoryGroupFilter] = useState({});

  const filterComponents = () => {
    if (fLoaded && Object.keys(fParams).length > 0) {
      return (
        <Box sx={{ mt: 3 }}>
          <SingleSelectType
            options={fParams.name.map((grp) => grp)}
            selected={historyGroupFilter}
            setSelected={setHistoryGroupFilter}
            label="Name"
            param={"name"}
            reset={reset}
          />
          <SingleSelectType
            options={["Add", "Remove", "Update"]}
            selected={historyGroupFilter}
            setSelected={setHistoryGroupFilter}
            label="Action"
            param={"action"}
            reset={reset}
          />
          <SingleSelectType
            id="true"
            options={[
              { name: "Approved", id: true },
              { name: "Not Approved", id: false },
            ]}
            selected={historyGroupFilter}
            setSelected={setHistoryGroupFilter}
            label="Approved"
            param={"is_approved"}
            reset={reset}
          />
        </Box>
      );
    }
  };

  const queryPage = (queryParams, filters) => {
    setLoaded(false);
    getHistoryGroupList({
      setResponse: setHistoryGroup,
      filter: filters || historyGroupFilter,
      setLoaded: setLoaded,
      queryParams: queryParams,
    });
    setPagination(queryParams);
  };

  const onFilterSubmit = () => {
    queryPage({
      page: 1,
      page_size: pagination.page_size,
    }, historyGroupFilter);
  };

  // ------------------ end of filter stuffies --------------------//

  useEffect(() => {
    if (reset) setReset(false);
  }, [reset]);

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  useEffect(() => {
    getHistoryGroupFilterConditions(setFParams, setFLoaded);
    queryPage(pagination);
  }, []);

  const formatData = (input) => {
    let tableData = [];
    const results = input?.results || [];
    results.forEach(({ id, name, created_at, is_approved, action }) => {
      tableData.push({
        id: id,
        name: name,
        created_on: parseDateTime(created_at),
        action: action,
        approved: (
          <>
            <Label variant="ghost" color={is_approved ? "success" : "error"}>
              {is_approved ? "YES" : "NO"}
            </Label>
          </>
        ),
      });
    });
    return tableData;
  };

  useEffect(() => {
    if (historyGroup) {
      setTableData(formatData(historyGroup));
    }
  }, [historyGroup]);

  return (
    <Container style={{ paddingLeft: 0, paddingRight: 0 }}>
      {loaded ? (
        <Card>
          <ListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            filter={true}
            loaded={loaded}
            filterFunction={filterComponents}
            onFilterSubmit={onFilterSubmit}
            setReset={setReset}
            csv={false}
          />
          <Scrollbar>
            <TableView
              rows={tableData}
              link={`/3/app/group-details~id~?action=true`}
              onSelectItem={(id) => setItemId(id)}
              count={historyGroup?.count || 0}
              query={filterName}
              data={historyGroup?.results || []}
              pagination={pagination}
              getNext={queryPage}
            />
          </Scrollbar>
        </Card>
      ) : (
        <CircularLoader />
      )}

      {itemId && (
        <CommonDialog
          title="Group Details"
          onClose={() => setItemId(null)}
        >
          <GroupDetails itemId={itemId} isViewHistory />
        </CommonDialog>
      )}
    </Container>
  );
}
